import React,{ useRef, useEffect } from "react";
import BasemapToggle from "@arcgis/core/widgets/BasemapToggle";
import Basemap from "@arcgis/core/Basemap";

const BasemapToggleWidget = ({view,mapId,mapEmbed=true,position="bottom-left"}) => {
    
    const basetogWidgetDiv = useRef(null);
    
    useEffect(()=> {
        if(basetogWidgetDiv.current){
            let basemapImagery = new Basemap({
                portalItem: {
                    id: mapId//"4cd1ca98be04433a976b71bc14d61769" //Eagle Aerial 2022 (1ft)
                }
            });

            const basetogWidget = new BasemapToggle({
                id:"basemapToggle",
                container: basetogWidgetDiv.current,
                view: view,
                nextBasemap: basemapImagery
            }) 

           if(mapEmbed){
            view.ui.add(basetogWidget,position)
           }
            return ()=> {
                basetogWidget.destroy()
            }
        }
    },[])
    
    return(
    <div ref={basetogWidgetDiv}></div>
    )   
}

export default BasemapToggleWidget